import { getCountryFlag } from '@/helpers'

export type ProductShippingStatusCopyByCountry = Partial<Record<string, string>>

// Product-page only: add per-country banner copy overrides here.
export const PRODUCT_SHIPPING_STATUS_COPY_BY_COUNTRY: ProductShippingStatusCopyByCountry =
  {
    GB: '🇬🇧 Free UK-based shipping',
    UK: '🇬🇧 Free UK-based shipping',
  }

export const getProductShippingStatusText = (
  country: string,
  hasFreeShipping: boolean | null | undefined,
  customCopyByCountry: ProductShippingStatusCopyByCountry = PRODUCT_SHIPPING_STATUS_COPY_BY_COUNTRY
) => {
  const normalizedCountry = country.toUpperCase()
  const customCopy = customCopyByCountry[normalizedCountry]
  if (customCopy) return customCopy
  if (hasFreeShipping === false) return null
  if (hasFreeShipping !== true) return null
  return `${getCountryFlag(country)} Free shipping to ${country}`
}

export const getProductShippingStatusDetailText = (
  country: string,
  countryName: string
) => {
  const normalizedCountry = country.toUpperCase()
  if (normalizedCountry === 'GB' || normalizedCountry === 'UK') {
    return 'Dispatches from our UK warehouse. Prices shown include VAT. See our returns policy for details.'
  }

  return `Dispatches from our UK warehouse to ${countryName}. VAT and import costs are shown before payment when available.`
}
